module.exports = __webpack_public_path__ + "img/guide.0a3e14fc.gif";